export { default } from './VAP';
